<template>
    <div class="search__wrapper">
        <div class="search__card">
            <h2 class="search__headline">Digitales Verzeichnis Durchsuchen</h2>
            <input v-model="searchId" class="search__input" name="search-id" type="text" placeholder="Mitgliedsnummer *" required>
            <button @click="goToLibary()" class="ht-btn ht-btn-md ht-btn--outline ht-btn-full">Stöbern</button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                searchId: null
            }
        },
        methods: {
            goToLibary() {
                if (!this.searchId) {
                    return this.$router.push({ name: 'Gallery' })
                }

                this.$router.push({ name: 'LibaryView', params: { id: this.searchId }})
            }
        }
    }
</script>

<style lang="scss">
@use '../assets/scss/_variabls' as vars;

.search {
    &__wrapper {
        width: 100vw;
        height: 50vh;
        padding: 4rem;
        position: relative;
        overflow: hidden;
        border-top: 8px solid vars.$theme-color--default-light;
        border-bottom: 8px solid vars.$theme-color--default-light;
        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: url(../assets/img/features/libary.webp) center/cover no-repeat;
            animation: background-zoom 4s ease-in-out infinite alternate;
            filter: blur(3px);
            z-index: 0;
        }

        @keyframes background-zoom {
            from {
                transform: scale(1);
            }
            to {
                transform: scale(1.1);
            }
        }
    }
    &__card {
        background: vars.$white;
        width: 100%;
        height: 100%;
        border-radius: .5rem;
        padding: 1rem;
        text-align: center;
        display: flex;
        gap: 1rem;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        overflow: hidden;
        box-shadow: -1px 3px 12px 0px rgba(15,15,15,0.77);
        &::after, &::before {
            content: '';
            position: absolute;
            top: -2rem;
            right: -2rem;
            width: 4rem;
            height: 4rem;
            background: vars.$theme-color--default-light;
            transform: rotate(45deg);
        }
        &::before {
            top: auto;
            right: auto;
            bottom: -2rem;
            left: -2rem;
        }
    }
    &__headline {
        font-size: 1.5rem;
    }
    &__input {
        color: vars.$theme-color--black;
        border-color: transparent;
        background: rgba(0, 0, 0, 0.07);
        width: 100%;
        border-radius: 5px;
        padding: 3px 20px;
        height: 56px;
        border: 1px solid transparent;
    }
}

@media #{vars.$desktop-up} {
    .search {
        &__card {
            width: 50%;
            margin: auto auto;
        }
    }
}

@media #{vars.$xlmax-up} {
    .search {
        &__card {
            width: 30%;
            margin: auto auto;
        }
    }
}
</style>